import React from 'react';
import {Row} from 'antd'


class NotFound extends React.Component {
  render () {

     return (	     
	   <div>
	 
	   <Row type="flex" justify="center" align="middle"  style={{ minWidth:'10vh',minHeight:'69vh'  }} >
				<h1 style={{fontSize:'2rem'}}>Welcome to Gold ShopKeeper Manager System. </h1>				
				</Row>
				
		</div>
    );
  }
}

export  default NotFound;
